import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import Card from '../components/card/card.component';
import Header from '../components/header/header.component';
import './home.scss';

const Home = () => {
  const Projects = [
    {
      title: 'weather app',
      app: 'weather-app',
      id: 1,
      imageUrl: 'https://www.linkpicture.com/q/Weather-App.png',
      desc: ' Using an application programming interface (API) to develop forecast data. This project show how to use API to access weather data to create a forecast, including temperature, humidity or precipitation.',
      usedTech: 'React, JavaScript, Scss',
      size: 'large',
    },
    {
      title: 'To-do List',
      app: 'to-do-list',
      id: 2,
      imageUrl: 'https://i.postimg.cc/8zt12gdB/Screenshot-41.png',
      desc: ' A to-do list app is a digital tool that helps individuals and teams manage their tasks, projects, and schedules more efficiently. It allows users to create a list of tasks or projects, set deadlines, add notes, and track progress towards completion.',
      usedTech: 'React, Scss, JSX',
      size: 'large',
    },
  ];
  return (
    <Fragment>
      <div className='home'>
        <Header />
        <div className='projcets-section'>
          {Projects.map((project) => (
            <Card key={project.key} project={project} />
          ))}
        </div>
      </div>
      <Outlet />
    </Fragment>
  );
};

export default Home;
